/**
 * Charactor Counter Module;
 * Allows developers to construct character counters around input/textarea elements
 *
 *  ### USAGE e.g. ##
 *  <input class="foo" value="">
 *  var c = new CharacterCounter($('.foo'), { ... })
 *
 *  Options are defined below in the defaults_ variable.
 *  @author Billy Bastardi (billy@yext.com)
 */
goog.module('yext.textutil.CharacterCounter');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

/**
 * @constructor
 *
 * @param {!jQuery} $el The element to bind the character counter to
 * @param {!Object} opts The configuration for our module
 */
const CharacterCounter = function($el, opts) {
  this.$el = $el;

  this.options = $.extend({}, CharacterCounter.defaults_, opts);

  this.$label = $('<span class="' + this.options.labelClass +'">' + this.getLabel() + '</span>');

  this.$ctx = this.$el.wrap('<div class="' + this.options.counterClass + '"></div>').parent();
  this.$ctx.append(this.$label);

  this.bindCounter();
};

CharacterCounter.defaults_ = {
  counterClass: 'character-count-wrap',
  includeLabelText: true,
  limit: 100,
  labelClass: 'character-counter',
  warningClass: 'txt-warning',
  onFocus: true, // only display the counter when the user is focused on the input
};

/**
 * update will handle rendering the label, showing how many characters are remaining
 * based on the character limit and the input/textarea length
 */
CharacterCounter.prototype.update = function() {
  this.$label
    .toggleClass(this.options.warningClass, this.$el.val().length > this.options.limit)
    .text(this.getLabel());
};

/**
 * getLabel is a helper function to get the label as a string, using values
 * @return {string} e.g. gets "0 characters remaining" from-> "%s characters remaining"
 */
CharacterCounter.prototype.getLabel = function() {
  var charactersRemaining = this.options.limit - this.$el.val().length;
  if (this.options.includeLabelText) {
    return yext.msgn(
      'characters remaining: 1',
      'characters remaining: {0}',
      charactersRemaining);
  } else {
    return charactersRemaining;
  }
};

/**
 * bindCounter handles listening to the input/textfield for changes, and updates
 * the counter label accordingly
 */
CharacterCounter.prototype.bindCounter = function() {
  // Meh, just incase we're invoked on the same node twice.
  this.unbindCounter();

  var that = this;
  if (this.options.onFocus === true) {
    this.$label.hide();

    this.$el.on('focus.charCounter', function() {
      that.$label.show();
    });

    this.$el.on('blur.charCounter', function() {
      that.$label.hide();
    });
  }

  this.$el.inputchange(function() {
    that.update();
  });
};

/**
 * unbindCounter removes all CharacterCounter event handlers
 */
CharacterCounter.prototype.unbindCounter = function() {
  this.$el.off('.charCounter');
};

/**
 * reset is just like update(), except it waits for the next UI event loop
 */
CharacterCounter.prototype.reset = function() {
  var that = this;
  // LocationEdit form fields get reset by 'native reset events', so in order to capture the proper value,
  // we wait for 1 additional event loop before updating our value
  setTimeout(function() {
    that.update();
  }, 0);
};

exports = CharacterCounter;
